import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Button } from 'blaze-ui/Button'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import Styles from './AddChannelDrawer.module.scss'
import { Service } from 'components/ArticlePostPreview/PostPreviewBody/IntegrationsDrawer/Service'
import { Text } from 'blaze-ui/Text/Text'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

const IntegrationOptions = [
  {
    provider: ExternalIntegrationEnum.Instagram,
    icon: <ChannelIcon channel={ChannelType.InstagramPosts} />,
    label: 'Instagram',
  },
  {
    provider: ExternalIntegrationEnum.LinkedIn,
    icon: <ChannelIcon channel={ChannelType.LinkedInPosts} />,
    label: 'LinkedIn',
  },
  {
    provider: ExternalIntegrationEnum.X,
    icon: <ChannelIcon channel={ChannelType.Tweets} />,
    label: 'X/Twitter',
  },
  {
    provider: ExternalIntegrationEnum.Facebook,
    icon: <ChannelIcon channel={ChannelType.FacebookPost} />,
    label: 'Facebook',
  },
]

export const AddChannelDrawer = observer(
  ({
    onChannelAdd,
    enabledChannels,
    ...props
  }: {
    onChannelAdd: (channel: ExternalIntegrationEnum) => void
    enabledChannels: ExternalIntegrationEnum[]
  } & DrawerProps) => {
    const { drawersStore } = useRootStore()
    return (
      <Drawer.Root {...props}>
        <Drawer.Portal>
          <Drawer.Overlay />
          <Drawer.Content>
            <Drawer.InnerContent>
              <Drawer.Top>
                <div />
                <Text>Add Channels</Text>
                <div className={Styles.closeButton}>
                  <Button variant="ghost" size="lg" onPress={() => drawersStore.closeDrawer()}>
                    Close
                  </Button>
                </div>
              </Drawer.Top>
              <Drawer.Container>
                <div className={Styles.container}>
                  {IntegrationOptions.filter((option) => !enabledChannels.includes(option.provider)).map((option) => (
                    <Service
                      key={option.provider}
                      onClick={() => onChannelAdd(option.provider)}
                      icon={option.icon}
                      label={option.label}
                    />
                  ))}
                </div>
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    )
  },
)
